import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard, GuestGuard} from "./core/services/auth-guard.service";

const baseRoutes: Routes = [
    {
        path: '',
        redirectTo: 'sales-dashboard',
        pathMatch: 'full'
    },
    {
        path: 'customer',
        loadChildren: () => import('./components').then(m => m.CustomerModule),
        data: { title: 'Customer' },
        canActivate: [AuthGuard]
    },
    {
        path: 'developer',
        loadComponent: () => import('./components/index').then(com => com.DevoloperComponent),
        data: { title: 'Developer' },
        canActivate: [AuthGuard]
    },
    {
        path: 'sales-dashboard',
        loadComponent: () => import('./components/index').then(com => com.SalesDashboardComponent),
        data: { title: 'Sales Dashboard' },
        canActivate: [AuthGuard]
    },
    {
        path: 'sales-map',
        loadComponent: () => import('./components/index').then(com => com.SalesMapComponent),
        data: { title: 'Sales Map' },
        canActivate: [AuthGuard]
    },
    {
        path: 'delivery-reliability',
        loadComponent: () => import('./components/feature/New-Modules/delivery-reliability/components/delivery-reliability-dashboard.component').then(m => m.DeliveryReliabilityDashboardComponent),
        data: { title: 'Delivery Reliability' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'order-performance',
        loadComponent: () => import('./components/feature/New-Modules/order-performance-dashboard/components/order-performance-dashboard.component').then(m => m.OrderPerformanceDashboardComponent),
        data: { title: 'Order Performance' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'lead-time',
        loadComponent: () => import('./components/feature/New-Modules/lead-time-dashboard/components/lead-time-dashboard.component').then(m => m.LeadTimeDashboardComponent),
        data: { title: 'Reliability Dashboard' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'delivery-status',
        loadComponent: () => import('./components/feature/New-Modules/order-delivery-status/components/order-delivery-status-dashboard.component').then(m => m.OrderDeliveryStatusDashboardComponent),
        data: { title: 'Flexibility Dashboard' },
        // Open to anyone — no AuthGuard, no permission gating.
    },
    {
        path: 'order-delivery-status',
        redirectTo: 'delivery-status',
        pathMatch: 'full'
    },
    {
        path: 'sales-order',
        loadChildren: () => import('./components').then(m => m.SalesOrderModule),
        data: { title: 'Sales Order' },
        canActivate: [AuthGuard]
    },
    {
        path: 'production-update',
        loadComponent: () => import('./components/index').then(com => com.ProductionUpdateComponent),
        data: { title: 'Production Update' },
        canActivate: [AuthGuard]
    },
    {
        path: 'work-order',
        loadChildren: () => import('./components').then(m => m.WorkOrderModule),
        data: { title: 'Work Order' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'production-planing',
        loadComponent: () => import('./components/index').then(com => com.ProductionPlanningComponent),
        data: { title: 'Production Planning' },
        canActivate: [AuthGuard]
    },
    {
        path: 'smart-planning',
        loadComponent: () => import('./components/index').then(com => com.SmartPlanningComponent),
        data: { title: 'Smart Planning' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'auto-schedule',
        loadComponent: () => import('./components/index').then(com => com.AutoScheduleComponent),
        data: { title: 'Auto Schedule' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'task-tracker',
        loadChildren: () => import('./components').then(m => m.TaskTrackerModule),
        data: { title: 'Task Tracker' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'reports',
        loadChildren: () => import('./components/feature').then(m => m.ReportsModule),
        data: { title: 'Reports' },
         canActivate: [AuthGuard]
    },
    {
        path: 'invoice',
        loadChildren: () => import('./components/feature').then(m => m.InvoiceModule),
        data: { title: 'Invoice' },
        canActivate: [AuthGuard]
    },
    {
        path: 'dispatch-note',
        loadChildren: () => import('./components').then(m => m.DispatchNoteModule),
        data: {title: 'Dispatch Note'},
        // canActivate: [AuthGuard],
    },
    {
        path: 'credit-note',
        loadChildren: () => import('./components').then(m => m.CreditNoteModule),
        data: { title: 'Credit Note' },
        canActivate: [AuthGuard]
    },
    {
        path: 'ncr',
        loadChildren: () => import('./components').then(m => m.NCRModule),
        data: { title: 'NCR' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'packaging',
        loadChildren: () => import('./components').then(m => m.PackagingModule),
        data: { title: 'Packaging' },
        canActivate: [AuthGuard]
    },
    {
        path: 'product-development',
        loadChildren: () => import('./components').then(m => m.ProductDevelopmentModule),
        data: { title: 'Product Development' },
        canActivate: [AuthGuard]
    },
    {
        path: 'compliance-certificate',
        loadChildren: () => import('./components').then(m => m.ComplianceCertificateModule),
        data: { title: 'Compliance Certificates' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'production-status',
        loadComponent: () => import('./components/index').then(com => com.ProductionStatusComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'sales-order-item',
        loadComponent: () => import('./components/index').then(com => com.SalesOrderItemComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'product-price',
        loadChildren: () => import('./components').then(m => m.PriceModule),
        data: { title: 'Product Price' },
        canActivate: [AuthGuard]
    },
    {
        path: 'stock-order',
        loadChildren: () => import('./components').then(m => m.StockOrderModule),
        data: { title: 'Stock Order' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'supplier',
        loadChildren: () => import('./components').then(m => m.SupplierModule),
        data: { title: 'Stock Order' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'production-update-status',
        loadComponent: () => import('./components/feature/New-Modules/production-update/components/index').then(m => m.ProductionUpdateStatusCreateComponent),
        data: { title: 'Production Update Status' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'inventory',
        loadChildren: () => import('./components').then(m => m.InventoryModule),
        data: { title: 'Inventory' },
        canActivate: [AuthGuard]
    },
    {
        path: 'mtn',
        loadChildren: () => import('./components').then(m => m.MtnModule),
        data: { title: 'MTN' },
        // canActivate: [AuthGuard]
    },    
    {
        // FG Pulse dashboard — open to anyone, no AuthGuard, no permission gating.
        // Declared before the guarded module route so it matches this exact URL first.
        path: 'finish-good-stores/dashboard',
        loadComponent: () => import('./components/feature/New-Modules/finish-good-stores/components/fg-dashboard/fg-dashboard.component').then(m => m.FgDashboardComponent),
        data: { title: 'FG Pulse' },
    },
    {
        path: 'finish-good-stores',
        loadChildren: () => import('./components').then(m => m.FinishGoodStoresModule),
        data: { title: 'Finish Good Stores' },
        canActivate: [AuthGuard]
    },
    {
        path: 'gin',
        loadChildren: () => import('./components').then(m => m.GINModule),
        data: { title: 'GIN' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'grn',
        loadChildren: () => import('./components').then(m => m.GRNModule),
        data: { title: 'Good Receive Note' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'mci',
        loadChildren: () => import('./components').then(m => m.MciModule),
        data: { title: 'Material Conversion Intake' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'stock-barcode',
        loadChildren: () => import('./components').then(m => m.StockBarcodeManageModule),
        data: { title: 'Stock Barcode Management' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'material-return-note',
        loadChildren: () => import('./components').then(m => m.MaterialReturnNoteModule),
        data: { title: 'Material Return Note' },
        // canActivate: [AuthGuard]
    },    
    {
        path: 'purchase-order',
        loadChildren: () => import('./components').then(m => m.PurchaseOrderModule),
        data: { title: 'Purchase Order' },
        canActivate: [AuthGuard]
    },
    {
        path: 'purchase-requisition',
        loadChildren: () => import('./components').then(m => m.PurchaseRequisitionModule),
        data: { title: 'Purchase Requisition' },
        // canActivate: [AuthGuard]
    },
    {
        path: 'supplier-price',
        loadChildren: () => import('./components').then(m => m.SupplierPriceModule),
        data: { title: 'Supplier Stand Prices' },
        // TEMP: AuthGuard disabled for local supplier-price testing — re-enable before commit
        canActivate: [AuthGuard],
    },
    {
        path: 'shipment-tracker',
        loadChildren: () => import('./components').then(m => m.ShipmentTrackerModule),
        data: { title: 'Shipment Tracker' },
        // TEMP: AuthGuard disabled for local supplier-price testing — re-enable before commit
        // canActivate: [AuthGuard],
    },
    {
        path: 'plans-per-sheet',
        loadComponent: () =>
            import('./components/feature/New-Modules/printing/components/plans-per-sheet/plans-per-sheet.component')
                .then(m => m.PlansPerSheetComponent),
        data: { title: 'Plans per sheet' },
        // TEMP: AuthGuard disabled for local testing — re-enable before commit
        // canActivate: [AuthGuard],
    },
    {
        path: 'delivery-change-request',
        loadComponent: () => import('./components/feature/New-Modules/production/components/date-change-request/date-change-request.component')
            .then(m => m.DateChangeRequestComponent),
        data: { title: 'Delivery Change Request' },
        canActivate: [AuthGuard]
    },
    {
        path: 'currency-exchange-rate',
        loadComponent: () => import('./components/feature/New-Modules/currency/currency-exchange-rate/currency-exchange-rate.component')
            .then(m => m.CurrencyExchangeRateComponent),
        data: { title: 'Exchange Rates' },
        canActivate: [AuthGuard]
    },
    {
        path: 'test',
        loadComponent: () => import('./components/feature/websocket-test/websocket-test.component')
            .then(m => m.WebsocketTestComponent),
        data: { title: 'WebSocket Test' },
    },
    {
        path: 'supplier-price-variation',
        loadChildren: () => import('./components').then(m => m.SupplierPriceVariationModule),
        data: { title: 'Supplier vs Item vs Price Analysis' },
        canActivate: [AuthGuard]
    },
    {
        path: 'email-signature',
        loadComponent: () => import('./components/feature/New-Modules/email-signature/email-signature-generator.component')
            .then(m => m.EmailSignatureGeneratorComponent),
        data: { title: 'Email Signature' },
        // Open to anyone — no AuthGuard, no permission gating.
    },
    {
        // ── Supplier Dashboard ─────────────────────────────────────────────
        // Groups:
        //   /supplier-dashboard/supplier-price-variation
        //   /supplier-dashboard/inventory-trend
        // Permission key: 'supplier-dashboard'
        path: 'supplier-dashboard',
        loadChildren: () => import('./components/feature').then(m => m.SupplierDashboardModule),
        data: { title: 'Supplier Dashboard' },
        canActivate: [AuthGuard]
    },
];

const routes: Routes = [
    ...baseRoutes,
    {
        path: 'login',
        loadComponent: () => import('./core/index').then(com => com.LoginComponent),
        data: { title: 'Login' },
        canActivate: [GuestGuard]
    },
    {
        path: '**',
        redirectTo: 'login'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
